import { createAsyncThunk } from '@reduxjs/toolkit';
import { get, put, post, deleteRequest } from 'utils/api';
import { successHandler } from 'common/utils/notifications';

/* Purchasing Groups Actions */
export const getPurchasingGroup = createAsyncThunk(
  'GET_PURCHASING_GROUPS',
  async (params, { rejectWithValue }) => {
    try {
      const res = await get('/enums/purchasing-groups', { ...params });

      return res.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const createPurchasingGroup = createAsyncThunk(
  'CREATE_PURCHASING_GROUPS',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const res = await post('/enums/purchasing-groups', params);
      dispatch(
        successHandler({ title: 'Success!', message: 'Purchasing group created successfully' })
      );

      return res.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const importCompaniesToPurchasingGroup = createAsyncThunk(
  'IMPORT_COMPANIES_TO_PURCHASING_GROUP',
  async (params, { rejectWithValue, dispatch }) => {
    const { id } = params;

    try {
      const res = await post(`/enums/purchasing-groups/${id}/import`, params);

      return res.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const editPurchasingGroup = createAsyncThunk(
  'EDIT_PURCHASING_GROUPS',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const { id, ...rest } = params;

      const res = await put(`/enums/purchasing-groups/${id}`, { ...rest });
      dispatch(successHandler({ title: 'Success!', message: 'Updated successfully' }));

      return res.data?.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const deletePurchasingGroup = createAsyncThunk(
  'DELETE_PURCHASING_GROUPS',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const { id } = params;

      const res = await deleteRequest(`/enums/purchasing-groups/${id}`);
      dispatch(successHandler({ title: 'Success!', message: 'Deleted successfully' }));

      return res.data?.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

/* -- */
